import { render, staticRenderFns } from "./VerifyClientToken.vue?vue&type=template&id=3ca473e1&scoped=true&"
import script from "./VerifyClientToken.vue?vue&type=script&lang=js&"
export * from "./VerifyClientToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca473e1",
  null
  
)

export default component.exports